import BigImg from '../../components/BigImg.vue';

var that;
var timer;
export default {
    setup() {
        const onClickLeft = () => history.back();
        return {
            onClickLeft,

        };
    },
    components: {
        BigImg,
    },

    data() {
        return {
            coupLists: [

            ],
            photoVisible: false,
            bigImgUrl: "",
            writeOffNum: 10,
            isWriteOffFlag: false,
        };
    },
    computed: {
        leftText() {
            // 可以在这里写复杂的 JS 逻辑
            return `商家核销数量：${this.writeOffNum}`
        }
    },
    created() {
        that = this;
        this.getCouponList();
        // setInterval(() => { //每5秒刷新一次图表
        //     this.getDhGoodsInfoList();
        // }, 5000);
        this.showWriteOffFlag();
    },

    mounted() {
        // timer = setInterval(() => { //每5秒刷新一次图表
        //     this.getDhGoodsInfoList();
        // }, 5000);

    },
    unmounted() {
        clearInterval(timer);
    },
    methods: {
        showBigImage(e) { //点击图片函数，点击后，把photoVisible设置成true
            if (e != "") {
                this.photoVisible = true;
                this.bigImgUrl = e.currentTarget.src;
            }
        },
        getCouponList() {
            // console.log(this.test);
            // console.log(this.$route.query.memberId);
            this.$api.getCouponList({
                params: {
                    memberId: this.$route.query.memberId + '',
                },
                success: function(res) {
                    console.log("resres", res);
                    that.coupLists = res.data
                }
            })
        },
        //判断是否商家管理员
        showWriteOffFlag() {
            // console.log(this.test);
            // console.log(this.$route.query.memberId);
            this.$api.isWriteOffFlag({
                params: {
                    memberId: this.$route.query.memberId + '',
                },
                success: function(res) {
                    console.log("isWriteOffFlag", res);
                    if(res.code == 0){
                        this.isWriteOffFlag = true;
                        //获取商家核销券的数量
                        this.$api.getWriteOffNum({
                            params: {
                                memberId: this.$route.query.memberId + '',
                            },
                            success: function(res) {
                                console.log("getWriteOffNum", res);
                                this.writeOffNum = res.data;
                            }.bind(this)
                        })
                    }
                }.bind(this)
            })
        },
        jumpInfo(id) {
            this.$router.push({
                path: '/couponDetail',
                query: {
                    couponId: id,
                    memberId: this.$route.query.memberId
                }
            })
        },

        goUrl() {
            this.$router.push({
                path: '/couponRecords',
                query: {
                    memberId: this.$route.query.memberId
                }
            })
        }


    }
};